/**
 * Auth cookie names, mirrored from the backend. The CSRF cookie is the
 * only one JS reads directly (HttpOnly access/refresh tokens are invisible
 * to script) but we keep all three here for grep-ability and to flag any
 * future client-side reader.
 *
 * Prefixed `dhze_` to avoid collisions with sibling Den Hartog apps on
 * the same parent domain. See backend/src/utils/cookieNames.ts.
 */
export const COOKIE_ACCESS = "dhze_access_token";
export const COOKIE_REFRESH = "dhze_refresh_token";
export const COOKIE_CSRF = "dhze_csrf_token";

/** Legacy unprefixed CSRF cookie — wiped during rollout, drop after a release. */
export const LEGACY_COOKIE_CSRF = "csrf-token";
